import React from "react";
import { Dropdown } from "react-bootstrap";
import { RiQuestionnaireFill } from "react-icons/ri";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

const Questionnaire = () => {
  const { trdr } = useParams();
  const questionnaires = useSelector((state) => state?.questionnaires);

  const navigate = useNavigate();

  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
      href=""
      style={{ color: "var(--bs-card-color)" }}
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      {children}
    </a>
  ));
  //onClick={() => navigate(`/customer/${trdr}/questionnaire/${1000}`)}
  return (
    <>
      <Dropdown>
        <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
          <RiQuestionnaireFill size={45} />
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {(Object.keys(questionnaires) ?? []).map((key) => {
            return (
              <Dropdown.Item eventKey={key} onClick={() => navigate(`/customer/${trdr}/questionnaire/${key}`)}>
                {questionnaires[key]?.name}
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default Questionnaire;
